import styled from "styled-components";

export const LoadingWrapper = styled.div<{ fullPage?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: ${({ fullPage }) => fullPage ? '90vh' : 'auto'};
`
